export default "__VITE_ASSET__Cic8i5TD__"